import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge } from "../Badge/Badge.js";
import styles from "./ScopePicker.module.css";
/**
 * Seleção múltipla de unidades na criação, do Azim CRM (ScopePicker).
 * Cada opção é um checkbox nativo (operável por teclado e por clique),
 * com meta-texto opcional e marcação visual de conflito.
 */
export function ScopePicker({ legend, options, selected, onToggle }) {
    return (_jsxs("fieldset", { className: styles.root, children: [_jsx("legend", { className: styles.legend, children: legend }), _jsx("div", { className: styles.list, children: options.map((opt) => {
                    const checked = selected.includes(opt.value);
                    return (_jsxs("label", { className: styles.option, children: [_jsx("input", { type: "checkbox", className: styles.checkbox, checked: checked, onChange: () => onToggle(opt.value) }), _jsxs("span", { className: styles.text, children: [_jsx("span", { className: styles.optionLabel, children: opt.label }), opt.meta && _jsx("span", { className: styles.meta, children: opt.meta })] }), opt.conflict && (_jsx(Badge, { tone: "warning", size: "sm", children: "Conflito" }))] }, opt.value));
                }) })] }));
}
//# sourceMappingURL=ScopePicker.js.map